import * as React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

// Selectors
import { makeSelectOptions } from './selectors';

interface Props {
    options: {
        key: number,
        text: string,
        content: string,
        value: number
    }[];
    children: React.Element<any> | Function;
}

export class EntityOptions extends React.PureComponent<Props> {
    render() {
        const { options, children } = this.props;

        if (typeof children === 'function') {
            return children(options);
        }

        return React.cloneElement(children, { options });
    }
}

const mapStateToProps = createStructuredSelector({
    options: makeSelectOptions()
});

export default connect(mapStateToProps)(EntityOptions);
